"use strict";
// Helper functions using the unified mapping
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCountryNameToOrganizationCountry = exports.convertCountryCodeToOrganizationCountry = exports.getRegionShortCodeFromCountryAndRegionName = exports.convertCountryNameToCountryCode = exports.convertCountryCodeToCountryName = exports.getRegion = exports.findCountryByNameOrCode = exports.getCountryFromCountryCode = exports.getCountry = exports.selectableCountryRegionData = exports.isSanctionedCountry = exports.SANCTIONED_COUNTRY_CODES = void 0;
const country_region_data_1 = __importDefault(require("country-region-data"));
const country_1 = require("../internationalization/enums/country");
const region_1 = require("../internationalization/region");
exports.SANCTIONED_COUNTRY_CODES = [
    country_1.CountryCode.AF,
    country_1.CountryCode.BY,
    country_1.CountryCode.CU,
    country_1.CountryCode.IR,
    country_1.CountryCode.KP,
    country_1.CountryCode.MM,
    country_1.CountryCode.RU,
    country_1.CountryCode.SY,
    country_1.CountryCode.VE,
];
const sanctionedCountryNames = country_region_data_1.default
    .filter((country) => exports.SANCTIONED_COUNTRY_CODES.includes(country.countryShortCode))
    .map((country) => country.countryName);
const isSanctionedCountry = (value) => {
    if (!value) {
        return false;
    }
    return exports.SANCTIONED_COUNTRY_CODES.includes(value) || sanctionedCountryNames.includes(value);
};
exports.isSanctionedCountry = isSanctionedCountry;
exports.selectableCountryRegionData = country_region_data_1.default.filter((country) => !exports.SANCTIONED_COUNTRY_CODES.includes(country.countryShortCode));
const getCountry = (countryName) => {
    return country_region_data_1.default.find((elem) => {
        return elem.countryName === countryName;
    });
};
exports.getCountry = getCountry;
const getCountryFromCountryCode = (countryCode) => {
    return country_region_data_1.default.find((elem) => {
        return elem.countryShortCode === countryCode;
    });
};
exports.getCountryFromCountryCode = getCountryFromCountryCode;
const findCountryByNameOrCode = (value) => {
    const lowerCasedValue = value.toLowerCase();
    return country_region_data_1.default.find((elem) => elem.countryName.toLowerCase() === lowerCasedValue || elem.countryShortCode === value);
};
exports.findCountryByNameOrCode = findCountryByNameOrCode;
const getRegion = (countryName, regionName) => {
    const country = (0, exports.getCountry)(countryName);
    return country?.regions.find((region) => region.name === regionName);
};
exports.getRegion = getRegion;
// CountryCode & CountryNames //
const convertCountryCodeToCountryName = (countryCode) => {
    return countryCode ? (0, exports.getCountryFromCountryCode)(countryCode)?.countryName : undefined;
};
exports.convertCountryCodeToCountryName = convertCountryCodeToCountryName;
const convertCountryNameToCountryCode = (countryName) => {
    return countryName ? (0, exports.getCountry)(countryName ?? "")?.countryShortCode : undefined;
};
exports.convertCountryNameToCountryCode = convertCountryNameToCountryCode;
// Region //
const getRegionShortCodeFromCountryAndRegionName = (countryName, regionName) => {
    return (0, region_1.resolveRegionCode)((0, exports.convertCountryNameToCountryCode)(countryName), regionName) ?? undefined;
};
exports.getRegionShortCodeFromCountryAndRegionName = getRegionShortCodeFromCountryAndRegionName;
// OrganizationCountry //
const convertCountryCodeToOrganizationCountry = (value) => {
    if (!value) {
        return country_1.DEFAULT_ORGANIZATION_COUNTRY;
    }
    const entry = Object.entries(country_1.ORGANIZATION_COUNTRY_MAP).find(([, mapping]) => mapping.countryCode === value);
    return entry?.[0] ?? country_1.DEFAULT_ORGANIZATION_COUNTRY;
};
exports.convertCountryCodeToOrganizationCountry = convertCountryCodeToOrganizationCountry;
const convertCountryNameToOrganizationCountry = (value) => {
    if (!value) {
        return country_1.DEFAULT_ORGANIZATION_COUNTRY;
    }
    const entry = Object.entries(country_1.ORGANIZATION_COUNTRY_MAP).find(([, mapping]) => mapping.countryName === value);
    return entry?.[0] ?? country_1.DEFAULT_ORGANIZATION_COUNTRY;
};
exports.convertCountryNameToOrganizationCountry = convertCountryNameToOrganizationCountry;
